import { createSlice } from "@reduxjs/toolkit";

import {
  addNewFixedAsset,
  deleteFixedAssetRegisterAction,
  getFixedAssetHistoryAction,
  fixedAssetBulkUploadDataAction,
  getFixedAssetId,
  getFixedAssetRegisterListing,
  getSingleFixedAsset,
  postFixedAssetVerificationAction,
  updateFixedAsset,
  getAuditSessionAction,
  createAuditSessionAction,
  updateAuditSessionAction,
  getFARUsersHistoryAction,
} from "@/redux/fixedAsset/actions";
import type { FixedAssetRegisterTypes } from "@/redux/fixedAsset/fixedAssetRegisterTypes";
import { initialState } from "@/redux/fixedAsset/initialState";
import { fixedAssetRegisterReducer } from "@/redux/fixedAsset/reducer";

export const fixedAssetRegisterSlice = createSlice({
  name: "fixedAssetRegister",
  initialState,
  reducers: fixedAssetRegisterReducer,

  extraReducers: (builder) => {
    builder.addCase(
      getFixedAssetId.pending,
      (state: FixedAssetRegisterTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getFixedAssetId.fulfilled,
      (state: FixedAssetRegisterTypes, { payload }) => {
        const { success, message, result, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          finacAssetId: result,
        };
      }
    );

    builder.addCase(
      getFixedAssetId.rejected,
      (state: FixedAssetRegisterTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      addNewFixedAsset.pending,
      (state: FixedAssetRegisterTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      addNewFixedAsset.fulfilled,
      (state: FixedAssetRegisterTypes, { payload }) => {
        const { success, message, result = {}, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            result,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          message,
        };
      }
    );

    builder.addCase(
      addNewFixedAsset.rejected,
      (state: FixedAssetRegisterTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getFixedAssetRegisterListing.pending,
      (state: FixedAssetRegisterTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getFixedAssetRegisterListing.fulfilled,
      (state: FixedAssetRegisterTypes, { payload }) => {
        const { success, message, result = {}, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            result,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          // message,
          finacAssetListing: result?.data,
          totalCount: result?.total_count,
        };
      }
    );

    builder.addCase(
      getFixedAssetRegisterListing.rejected,
      (state: FixedAssetRegisterTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getSingleFixedAsset.pending,
      (state: FixedAssetRegisterTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getSingleFixedAsset.fulfilled,
      (state: FixedAssetRegisterTypes, { payload }) => {
        const { success, message, result = {}, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            result,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          // message,
          singleFixedAsset: result,
        };
      }
    );

    builder.addCase(
      getSingleFixedAsset.rejected,
      (state: FixedAssetRegisterTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      updateFixedAsset.pending,
      (state: FixedAssetRegisterTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateFixedAsset.fulfilled,
      (state: FixedAssetRegisterTypes, { payload }) => {
        const { success, message, result = {}, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            result,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          message,
        };
      }
    );

    builder.addCase(
      updateFixedAsset.rejected,
      (state: FixedAssetRegisterTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      deleteFixedAssetRegisterAction.pending,
      (state: FixedAssetRegisterTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      deleteFixedAssetRegisterAction.fulfilled,
      (state: FixedAssetRegisterTypes, { payload }) => {
        const { success, message, result = {}, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            result,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          message,
        };
      }
    );

    builder.addCase(
      deleteFixedAssetRegisterAction.rejected,
      (state: FixedAssetRegisterTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      fixedAssetBulkUploadDataAction.pending,
      (state: FixedAssetRegisterTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      postFixedAssetVerificationAction.pending,
      (state: FixedAssetRegisterTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      postFixedAssetVerificationAction.fulfilled,
      (state: FixedAssetRegisterTypes, { payload }) => {
        const { success, message, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          message,
        };
      }
    );

    builder.addCase(
      postFixedAssetVerificationAction.rejected,
      (state: FixedAssetRegisterTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      fixedAssetBulkUploadDataAction.fulfilled,
      (state: FixedAssetRegisterTypes, { payload }) => {
        const { success, message, data = {}, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,

          bulkUploadData: payload,
        };
      }
    );

    builder.addCase(
      fixedAssetBulkUploadDataAction.rejected,
      (state: FixedAssetRegisterTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getFixedAssetHistoryAction.pending,
      (state: FixedAssetRegisterTypes) => ({
        ...state,
        fixedAssetHistorFetching: true,
      })
    );

    builder.addCase(
      getFixedAssetHistoryAction.fulfilled,
      (state: FixedAssetRegisterTypes, { payload }) => {
        const { success, message, status_code, result } = payload;

        if (success === 0) {
          return {
            ...state,
            fixedAssetHistorFetching: false,
            error: message,
            fixedAssetHistorySuccess: success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fixedAssetHistorFetching: false,
          fixedAssetHistorySuccess: success,
          statusCode: status_code,
          fixedAssetHistoryData: result?.data,
          message,
        };
      }
    );

    builder.addCase(
      getFixedAssetHistoryAction.rejected,
      (state: FixedAssetRegisterTypes, { error }) => ({
        ...state,
        fixedAssetHistorFetching: false,
        fixedAssetHistorySuccess: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getAuditSessionAction.pending,
      (state: FixedAssetRegisterTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAuditSessionAction.fulfilled,
      (state: FixedAssetRegisterTypes, { payload }) => {
        const { status_code, result, message, success } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          auditSessionListing: result,
        };
      }
    );

    builder.addCase(
      getAuditSessionAction.rejected,
      (state: FixedAssetRegisterTypes, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      createAuditSessionAction.pending,
      (state: FixedAssetRegisterTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      createAuditSessionAction.fulfilled,
      (state: FixedAssetRegisterTypes, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      createAuditSessionAction.rejected,
      (state: FixedAssetRegisterTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      updateAuditSessionAction.pending,
      (state: FixedAssetRegisterTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateAuditSessionAction.fulfilled,
      (state: FixedAssetRegisterTypes, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          message,
        };
      }
    );

    builder.addCase(
      updateAuditSessionAction.rejected,
      (state: FixedAssetRegisterTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getFARUsersHistoryAction.pending,
      (state: FixedAssetRegisterTypes) => ({
        ...state,
        assetHistoryFetching: true,
      })
    );

    builder.addCase(
      getFARUsersHistoryAction.fulfilled,
      (state: FixedAssetRegisterTypes, { payload }) => {
        const { result, success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            assetHistoryFetching: false,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          assetHistoryFetching: false,
          success,
          statusCode: status_code,
          fixedAssetUsersHistoryData: result,
          message,
        };
      }
    );

    builder.addCase(
      getFARUsersHistoryAction.rejected,
      (state: FixedAssetRegisterTypes, { error }) => ({
        ...state,
        assetHistoryFetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );
  },
});

export const {
  resetFixedAssetRegisterError,
  resetFixedAssetRegisterSuccess,
  resetFixedAssetRegisterFetching,
  resetFinacAssetId,
  resetFixedAssetRegisterListing,
  resetFixedAssetRegisterMessage,
  resetSingleFixedAsset,
  resetFixedAssetRegisterTotalCount,
  resetFixedAssetRegisterStatusCode,
  resetFixedAssetHistoryData,
  resetFixedAssetHistorySuccess,
  resetBulkUpload,
  resetFixedAssetUsersHistoryData,
} = fixedAssetRegisterSlice.actions;
